import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import * as PropTypes from 'prop-types';

import ErrorLayout from '$landing-page/layouts/error-layout';

const query = graphql`
    query errorNotFoundPage {
        image: file(relativePath: { eq: "page-error-not-found.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, width: 360, quality: 100, placeholder: NONE)
            }
        }
    }
`;

const ErrorNotFoundPage = (props) => {
    const { location } = props;
    const queryData = useStaticQuery(query);
    return (
        <ErrorLayout
            pathname={location.pathname}
            image={queryData.image}
            title="Not Found"
            description="Sorry, the page you are looking for does not exist."
            showContactUs={false}
        />
    );
};

ErrorNotFoundPage.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
};

export default ErrorNotFoundPage;
